import React, { useEffect, useState } from 'react';
import './BuildItem.scss';  // Import the CSS file
import { DashGridItem } from '../../DashGrid';
import { Modal, Button, Icon } from 'semantic-ui-react';
import { useCentralCalls } from '@src/rest/CentralCalls';
import { FinePrintMessage } from '@src/views/components/util/messaging/FinePrintMessage';
interface BuildItemProps {
    item: DashGridItem;
    DeleteGridItem: (x: number, y: number) => void;  // Add the delete function from the parent
}

const BuildItem: React.FC<BuildItemProps> = ({ item, DeleteGridItem }) => {
    const [modalOpen, setModalOpen] = useState(false); 

    const openModal = (e: React.MouseEvent) => {
        e.stopPropagation();  // Prevent parent onClick from triggering
        setModalOpen(true);
    };

    const closeModal = (e: React.MouseEvent) => {
        e.stopPropagation();  // Prevent parent onClick from triggering
        setModalOpen(false);
    };

    const handleDelete = (e: React.MouseEvent) => {
        e.stopPropagation(); 
        console.log('handle delete' + item.coordinateX + ',' + item.coordinateY);
        DeleteGridItem(item.coordinateX, item.coordinateY);  
        setModalOpen(false); 
    };

    return (
        <div className="build-item" style={{ position: 'relative' }}>
            <Icon 
                name="trash" 
                color="red" 
                size="large" 
                onClick={openModal}  
                style={{ 
                    cursor: 'pointer', 
                    position: 'absolute', 
                    top: '10px', 
                    right: '10px', 
                    zIndex: 1 
                }} 
                title="Delete this item"
            />

            <h4>{item.title}</h4>

            
            <div>
                <strong>Coordinates:</strong> X: {item.coordinateX || 0}, Y: {item.coordinateY || 0}
            </div>
            <Modal size="tiny" open={modalOpen} onClose={closeModal}>
                <Modal.Header>Delete Confirmation</Modal.Header>
                <Modal.Content>
                    <FinePrintMessage>Are you sure you want to delete this grid item?</FinePrintMessage>
                </Modal.Content>
                <Modal.Actions>
                    <Button onClick={closeModal} negative>
                        No
                    </Button>
                    <Button onClick={handleDelete} positive>
                        Yes
                    </Button>
                </Modal.Actions>
            </Modal>
        </div>
    );
};

export default BuildItem;